﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { WmoToMetarWeatherFormatter } from "../../Formatters/WmoToMetarWeatherFormatter";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { CloudChart } from "./CloudChart";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { ValueBox } from "./ValueBox";

export class Clouds implements ISiteObservationsPage {

    public id: string = 'clouds';
    public label: string = 'Clouds';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;

    constructor(public mainSite: MainSite, public ctx: ILiveDataListenerContext) {
    }

    public notifyResize() {
    }

    public show(station: ParameterSchemaStation): boolean {

        let sensorCount = 0;

        for (let sensorId in station.Sensors) {
            sensorCount++;

            const sensor = station.Sensors[sensorId];

            for (let paramId in sensor.Parameters) {
                if (paramId.indexOf('Cloud') != -1) {
                    return true;
                }
            }
        }
        return false;
    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;

        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');


        var leftPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '47em')
            .css('width', '16em')
            .css('left', '48em')
            .appendTo(page);

        var rightPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '47em')
            .css('left', '0em')
            .css('width', '46em')
            .appendTo(page);

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Third_CloudBaseHeight_ft_Inst),
                0, 0, 14, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Second_CloudBaseHeight_ft_Inst),
                15, 0, 14, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudBaseHeight_ft_Inst),
                30, 0, 14, 100, this.ctx)
            );


        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Visibility_m),
                45, 0, 13, 100, this.ctx)
            );


        listeners.push(
            new ValueBox(this,
                leftPanel,
                new WmoToMetarWeatherFormatter(),
                59, 0, 13, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.RainfallIntensity_mmphour),
                73, 0, 13, 100, this.ctx)
            );


        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.SolarRadiation_mWpcm2),
                87, 0, 13, 100, this.ctx)
            );


        var cloudContainer = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '45%')
            .css('top', '55%')
            .css('width', '100%')
            .appendTo(rightPanel);

        listeners.push(
            new CloudChart(this.mainSite,
                this,
                rightPanel,
                0, 0, 54, 100)
            );

        $('<div class="midi_SiteObservations_cloud_header">Cloud</div>').appendTo(cloudContainer);

        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 16%;">Layer 3</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 44%;">Layer 2</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 72%;">Layer 1</div>').appendTo(cloudContainer);

        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 24%;">Amount</div>').appendTo(cloudContainer);
        $(`<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 62%;">Height (${MainSite.getUnitConverter().getConvertedUnits(ParameterGroupInfoSet.First_CloudBaseHeight_ft.Units, ParameterGroupInfoSet.First_CloudBaseHeight_ft.Id)})</div>`).appendTo(cloudContainer);

        var cloudDataContainer = $('<div></div')
            .css('position', 'absolute')
            .css('top', '16%')
            .css('left', '24%')
            .css('height', '84%')
            .css('width', '76%')
            .appendTo(cloudContainer);

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Third_CloudCover),
                0, 0, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Second_CloudCover),
                33, 0, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudCover),
                66, 0, 34, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Third_CloudBaseHeight_ft),
                0, 50, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Second_CloudBaseHeight_ft),
                33, 50, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudBaseHeight_ft),
                66, 50, 34, 50, this.ctx,
                false)
            );

        page.appendTo(container);
    }
}